"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newSecurePassphrase = void 0;
const __1 = require("..");
async function newSecurePassphrase(size = 6) {
    return (await (0, __1.newSecureWords)(size)).join('-');
}
exports.newSecurePassphrase = newSecurePassphrase;
